var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricIconTotalQueActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16953_326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5.81818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.746094,
    width: 30.5,
    height: 30.5,
    rx: 5.06818,
    stroke: "#C728FF",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16953_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 21.9961C16.6174 21.9961 17.1211 21.4924 17.1211 20.8711C17.1211 20.2498 16.6174 19.7461 15.9961 19.7461C15.3748 19.7461 14.8711 20.2498 14.8711 20.8711C14.8711 21.4924 15.3748 21.9961 15.9961 21.9961Z",
    fill: "#C728FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 17.4961V16.7461C17.6527 16.7461 18.9961 15.5705 18.9961 14.1211C18.9961 12.6717 17.6527 11.4961 15.9961 11.4961C14.3395 11.4961 12.9961 12.6717 12.9961 14.1211V14.4961",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 24.9961C20.9667 24.9961 24.9961 20.9667 24.9961 15.9961C24.9961 11.0255 20.9667 6.99609 15.9961 6.99609C11.0255 6.99609 6.99609 11.0255 6.99609 15.9961C6.99609 20.9667 11.0255 24.9961 15.9961 24.9961Z",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.296094,
    y: 0.296094,
    width: 31.4,
    height: 31.4,
    rx: 4.7,
    stroke: "#C728FF",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16953_326"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16953_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3.99609 3.99609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconTotalQueActivity);
export default __webpack_public_path__ + "static/media/MetricIconTotalQue-activity.d84f41344bfce7ae39d5bd25e8602e1c.svg";
export { ForwardRef as ReactComponent };